import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const updateAssetPrice = createAsyncThunk(
  'prices/updateAssetPrice',

  async (asset: string) => {
    const response = await fetch(
      `https://min-api.cryptocompare.com/data/price?fsym=${asset}&tsyms=USD`
    );
    return (await response.json()).USD;
  }
);

const pricesSlice = createSlice({
  name: 'prices',
  initialState: { btcusd: 0, ethusd: 0, sushiusd: 0 },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateAssetPrice.fulfilled, (state, action) => {
      const asset = action.meta.arg;
      state[`${asset}usd`] = action.payload;
    });
  },
});

export { updateAssetPrice };
export default pricesSlice.reducer;
